import React, { useState } from "react";
// import { NextButton, PreviousButton } from "../Common/UI/NavBtns/NavBtns";

export const PatientParticulars = ({
  setPatientMedicationInfo,
  patientMedicationInfo,
}) => {
  const [patientParticularsState, setPatienParticulars] = useState({
    FirstName: "",
    lasteName: "",
    age: "",
    height: "5.6",
    weight: "60",
  });
  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setPatientMedicationInfo({
      ...patientMedicationInfo,
      [name]: value,
    });
  };

  return (
    <div className="shadowsForMainWrappe 2xl:p-10 xl:p-10 lg:p-10 md:p-4 p-3 rounded-xl bg-white">
      <div className="2xl:mb-16 xl:mb-16 lg:mb-16 md:mb-16 mb-6 2xl:py-4 xl:py-4 lg:py-4 md:py-4 py-2 border-b border-[#d4d4d4]">
        <h3 className="font-mainFont font-[600] text-mainColor 2xl:text-[1.4vw] xl:text-[1.4vw] lg:text-[1.4vw] md:text-[1.4vw] text-[6vw]">
          Enter Your Details
        </h3>
      </div>

      <form className="2xl:my-6 xl:my-6 lg:my-6 md:my-6 my-2 flex flex-col gap-10 ">
        <div className="flex flex-col 2xl:flex-row xl:flex-row lg:flex-row md:flex-col justify-between items-center gap-4">
          <div className="flex-1 w-full flex flex-col justify-start items-start gap-3">
            <label
              htmlFor="fristName"
              className="font-mainFont font-[500] 2xl:text-[.95vw] xl:text-[.95vw] lg:text-[.95vw] md:text-[.95vw] text-[3.2vw] text-[#333333] "
            >
              First name 
            </label>
            <input
              className=" w-full px-4 py-2 rounded-full inputShado  outline-none font-mainFont font-[500] 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] placeholder:text-[#333333] border border-[#d4d4d4] placeholder:font-[400] text-black bg-[#f0f0f0]"
              type="text"
              id="fristName"
              placeholder="Enter Your First Name"
              value={patientMedicationInfo.firstName}
              name="firstName"
              onChange={handleOnChange}
            />
          </div>
          <div className="flex-1 w-full flex flex-col justify-start items-start gap-3">
            <label
              htmlFor="lastName"
              className="font-mainFont font-[500] 2xl:text-[.95vw] xl:text-[.95vw] lg:text-[.95vw] md:text-[.95vw] text-[3.2vw] text-[#333333] "
            >
              Last name 
            </label>
            <input
               className=" w-full px-4 py-2 rounded-full inputShado  outline-none font-mainFont font-[500] 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] placeholder:text-[#333333] border border-[#d4d4d4] placeholder:font-[400] text-black bg-[#f0f0f0]"
              type="text"
              id="lastName"
              placeholder="Enter Your Last Name"
              value={patientMedicationInfo.lastName}
              name="lastName"
              onChange={handleOnChange}
            />
          </div>

          <div className="flex-1 w-full flex flex-col justify-start items-start gap-3">
            <label
              htmlFor="DOB"
              className="font-mainFont font-[500] 2xl:text-[.95vw] xl:text-[.95vw] lg:text-[.95vw] md:text-[.95vw] text-[3.2vw] text-[#333333] "
            >
              Enter Age
            </label>
            <input
               className=" w-full px-4 py-2 rounded-full inputShado  outline-none font-mainFont font-[500] 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] placeholder:text-[#333333] border border-[#d4d4d4] placeholder:font-[400] text-black bg-[#f0f0f0]"
              type="text"
              id="DOB"
              placeholder="Enter Your Age"
              value={patientMedicationInfo.age}
              name="age"
              onChange={handleOnChange}
            />
          </div>
        </div>

        <div className="w-full flex flex-col 2xl:flex-row xl:flex-row lg:flex-row md:flex-col justify-between items-center gap-10">
          <div className="flex-1 w-full flex flex-col justify-start items-start gap-1">
            <label
              htmlFor="height"
              className="font-mainFont font-[500] 2xl:text-[1.2vw] xl:text-[1.2vw] lg:text-[1.2vw] md:text-[1.2vw] text-[3.5vw] text-mainColor flex justify-start gap-6 items-center w-full"
            >
              <span className="font-mainFont font-[500] 2xl:text-[.95vw] xl:text-[.95vw] lg:text-[.95vw] md:text-[.95vw] text-[3.5vw] text-[#333333]">
                Height
              </span>
              <span className="2xl:text-[1.2dvw] xl:text-[1.2dvw] lg:text-[1.2dvw]md:text-[1.2dvw] text-[4dvw] font-[600] text-[#DB9A31]">
                {patientMedicationInfo.height
                  ? patientMedicationInfo.height
                  : patientParticularsState.height} <span className="2xl:text-[.95vw] xl:text-[.95vw] lg:text-[.95vw] md:text-[.95vw] text-[3.5vw]">feet</span>
              </span>
            </label>
            <input
              className=" w-full p-3 rounded-md border-2 outline-none border-[#CDCDCD] font-mainFont font-[500] text-[1vw] placeholder:text-mainColor/50 text-mainColor"
              type="range"
              id="height"
              placeholder="Enter Your Height"
              value={patientMedicationInfo.height}
              name="height"
              onChange={handleOnChange}
              max={7.5}
              min={0}
              step={0.1}
            />
          </div>

          <div className="flex-1 w-full flex flex-col justify-start items-start gap-1">
            <label
              htmlFor="weight"
              className="font-mainFont font-[500] text-[1.2vw] text-mainColor w-full flex justify-start gap-6 items-center"
            >
              <span className="font-mainFont font-[500] 2xl:text-[.95vw] xl:text-[.95vw] lg:text-[.95vw] md:text-[.95vw] text-[3.5vw] text-[#333333]">
                Weight
              </span>
              <span className="2xl:text-[1.2dvw] xl:text-[1.2dvw] lg:text-[1.2dvw]md:text-[1.2dvw] text-[4dvw] font-[600] text-[#DB9A31]">
                {patientMedicationInfo.weight
                  ? patientMedicationInfo.weight
                  : patientParticularsState.weight}{" "}
                  <span className="2xl:text-[.95vw] xl:text-[.95vw] lg:text-[.95vw] md:text-[.95vw] text-[3.5vw]">Kgs</span>
              </span>
            </label>
            <input
              className=" w-full p-3 rounded-md border-2 outline-none border-[#CDCDCD] font-mainFont font-[500] text-[1vw] placeholder:text-mainColor/50 text-mainColor rangeColor"
              type="range"
              id="weight"
              placeholder="Enter Your Weight"
              value={patientMedicationInfo.weight}
              name="weight"
              step={1}
              min={0}
              max={150}
              onChange={handleOnChange}
            />
          </div>
        </div>
      </form>
    </div>
  );
};
